// Shared auth-session helpers. Centralizes the localStorage-clear + redirect
// sequence that was previously duplicated inline in Login.js and Home.js.

export const clearAuthAndRedirect = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userData');
  localStorage.clear();
  if (window.location.pathname !== '/') {
    window.location.href = '/';
  }
};
